(() => {
  if (window.odisseiaInit) return;
  window.odisseiaInit = true;

  const FAV_KEY = 'odisseia-favoritos';
  const readFavs = () => {
    try {
      return JSON.parse(localStorage.getItem(FAV_KEY)) || [];
    } catch (e) {
      return [];
    }
  };
  const writeFavs = (list) => {
    try {
      localStorage.setItem(FAV_KEY, JSON.stringify(list));
    } catch (e) {
      /* sin almacenamiento: el corazón funciona solo en esta visita */
    }
  };

  const syncFavs = () => {
    const favs = readFavs();
    document.querySelectorAll('[data-odi-fav]').forEach((btn) => {
      btn.setAttribute('aria-pressed', favs.includes(btn.dataset.odiFav) ? 'true' : 'false');
    });
  };

  const announce = (btn, msg) => {
    const live = btn.closest('section')?.querySelector('[data-odi-live]');
    if (live) live.textContent = msg;
  };

  const addToCart = async (btn) => {
    btn.disabled = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.odiAdd), quantity: 1 }], sections: 'cart-icon-bubble' }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Error');

      btn.textContent = btn.dataset.labelAdded || btn.textContent;
      btn.classList.add('is-added');
      btn.removeAttribute('data-odi-add');

      const bubble = document.getElementById('cart-icon-bubble');
      const html = data.sections && data.sections['cart-icon-bubble'];
      if (bubble && html) {
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'odisseia-product-card' });
      }
      announce(btn, btn.dataset.msgAdded || '');
    } catch (e) {
      btn.disabled = false;
      announce(btn, e.message);
    }
  };

  document.addEventListener('click', (event) => {
    const fav = event.target.closest('[data-odi-fav]');
    if (fav) {
      const handle = fav.dataset.odiFav;
      let favs = readFavs();
      favs = favs.includes(handle) ? favs.filter((h) => h !== handle) : favs.concat(handle);
      writeFavs(favs);
      fav.setAttribute('aria-pressed', favs.includes(handle) ? 'true' : 'false');
      return;
    }
    const add = event.target.closest('[data-odi-add]');
    if (add && !add.disabled) addToCart(add);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFavs);
  } else {
    syncFavs();
  }
  document.addEventListener('shopify:section:load', syncFavs);
})();
